import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import {
  Component,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';

interface TagPayload {
  name: string;
}

@Component({
  selector: 'app-add-tag',
  standalone: false,
  templateUrl: './add-tag.html',
  styleUrl: './add-tag.scss',
})
export class AddTag implements OnInit{
  pageTitle = 'Add New Tag';

  pageSubtitle =
    'Create and organize a new course tag.';

  tagForm!: FormGroup;

  isSubmitted = false;
  isSaving = false;

  private saveAnotherAfterSubmit = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  get nameControl(): AbstractControl {
    return this.tagForm.get(
      'name'
    ) as AbstractControl;
  }

  submitTag(): void {
    this.saveTag(false);
  }

  saveAndAddAnother(): void {
    this.saveTag(true);
  }

  cancel(): void {
   window.history.back();
  }

  private initializeForm(): void {
    this.tagForm =
      this.formBuilder.group({
        name: [
          '',
          [
            Validators.required,
            Validators.maxLength(100)
          ]
        ]
      });
  }

  private saveTag(
    saveAnother: boolean
  ): void {
    this.isSubmitted = true;
    this.saveAnotherAfterSubmit =
      saveAnother;

    if (
      this.tagForm.invalid ||
      this.isSaving
    ) {
      this.tagForm.markAllAsTouched();
      return;
    }

    const formValue =
      this.tagForm.getRawValue();

    const payload: TagPayload = {
      name: formValue.name.trim()
    };

    this.isSaving = true;

    console.log(
      'Tag payload:',
      payload
    );

    /*
    Replace the timeout with your API:

    this.tagService
      .createTag(payload)
      .pipe(
        finalize(() => {
          this.isSaving = false;
        })
      )
      .subscribe({
        next: () => {
          this.handleSaveSuccess();
        },
        error: (error) => {
          console.error(
            'Tag creation failed:',
            error
          );
        }
      });
    */

    setTimeout(() => {
      this.isSaving = false;
      this.handleSaveSuccess();
    }, 800);
  }

  private handleSaveSuccess(): void {
    this.isSubmitted = false;

    if (this.saveAnotherAfterSubmit) {
      this.resetForm();
      return;
    }

    this.router.navigate([
      '/admin/course-reference/tags'
    ]);
  }

  private resetForm(): void {
    this.tagForm.reset({
      name: ''
    });

    this.saveAnotherAfterSubmit = false;
  }
}
